import { useQuery } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { BirthDayMonthPatientsReportResponse } from "@/types";

type Props = {
  page: string | null;
  month: string;
  perPage?: string | null;
};

async function fetchBirthDayMonthPatientReport({ page, month, perPage }: Props): Promise<BirthDayMonthPatientsReportResponse> {
  const response = await httpRequest.get<BirthDayMonthPatientsReportResponse>(
    `/patients-birthdays?page=${page || 1}&month=${month}&per_page=${perPage || 10}`,
  );
  return response.data;
}

export function useFetchBirthDayMonthPatientReportQuery({ page, month, perPage }: Props) {
  const birthDayMonthPatientReportQuery = useQuery({
    queryKey: ["patients-birthdays", page, month, perPage],
    queryFn: () => fetchBirthDayMonthPatientReport({ page, month, perPage }),
    keepPreviousData: true,
  });

  return {
    ...birthDayMonthPatientReportQuery,
    data: birthDayMonthPatientReportQuery.data,
  };
}
